/* SpeedyReorder: My Printer List.
   Storage is isolated behind this module (browser localStorage today) so it
   can later be swapped for customer-metafield sync without touching callers. */
window.SpeedyReorder = (function () {
  var FLEET_KEY = 'sr_fleet';
  var LOCKED_KEY = 'sr_list_locked';
  var LEGACY_GARAGE_KEY = 'sr_garage';

  function read(key, fallback) {
    try {
      var raw = localStorage.getItem(key);
      return raw ? JSON.parse(raw) : fallback;
    } catch (e) {
      return fallback;
    }
  }

  function write(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {}
  }

  function emit(name) {
    document.dispatchEvent(new CustomEvent(name));
  }

  /* One-time migration: the old "My Printer" (single, locked) feature is
     folded into My Printer List. Any saved single printer becomes a list
     entry (with no cartridges yet) and its locked flag becomes the list's
     locked-in mode, unless the list already has its own setting. */
  function migrateLegacyGarage() {
    try {
      var raw = localStorage.getItem(LEGACY_GARAGE_KEY);
      if (!raw) return;
      var garage = JSON.parse(raw);
      var fleet = read(FLEET_KEY, []);
      fleet.forEach(function (f) {
        if (!f.products) f.products = f.product ? [f.product] : [];
      });

      if (garage && garage.collectionHandle) {
        var alreadyListed = fleet.some(function (f) { return f.collectionHandle === garage.collectionHandle; });
        if (!alreadyListed) {
          fleet.push({
            id: 'sr_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8),
            label: garage.collectionTitle,
            collectionHandle: garage.collectionHandle,
            collectionTitle: garage.collectionTitle,
            products: []
          });
          write(FLEET_KEY, fleet);
        }
      }

      if (localStorage.getItem(LOCKED_KEY) === null) {
        write(LOCKED_KEY, !!(garage && garage.locked));
      }

      localStorage.removeItem(LEGACY_GARAGE_KEY);
    } catch (e) {}
  }

  migrateLegacyGarage();

  function getFleet() {
    var fleet = read(FLEET_KEY, []);
    /* Older saved entries used a single `product` field; normalize to `products` on read. */
    fleet.forEach(function (f) {
      if (!f.products) {
        f.products = f.product ? [f.product] : [];
      }
    });
    return fleet;
  }

  function saveFleetEntry(entry) {
    var fleet = getFleet();
    if (entry.id) {
      var idx = -1;
      for (var i = 0; i < fleet.length; i++) {
        if (fleet[i].id === entry.id) { idx = i; break; }
      }
      if (idx > -1) {
        fleet[idx] = entry;
        write(FLEET_KEY, fleet);
        emit('speedyreorder:fleet-updated');
        return entry;
      }
    }
    entry.id = 'sr_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
    fleet.push(entry);
    write(FLEET_KEY, fleet);
    emit('speedyreorder:fleet-updated');
    return entry;
  }

  function removeFleetEntry(id) {
    var fleet = getFleet().filter(function (f) { return f.id !== id; });
    write(FLEET_KEY, fleet);
    emit('speedyreorder:fleet-updated');
  }

  function addProductToEntry(entryId, product) {
    var fleet = getFleet();
    var idx = -1;
    for (var i = 0; i < fleet.length; i++) {
      if (fleet[i].id === entryId) { idx = i; break; }
    }
    if (idx === -1) return null;
    var already = fleet[idx].products.some(function (p) { return p.variantId === product.variantId; });
    if (!already) fleet[idx].products.push(product);
    delete fleet[idx].product;
    write(FLEET_KEY, fleet);
    emit('speedyreorder:fleet-updated');
    return fleet[idx];
  }

  function removeProductFromEntry(entryId, variantId) {
    var fleet = getFleet();
    var idx = -1;
    for (var i = 0; i < fleet.length; i++) {
      if (fleet[i].id === entryId) { idx = i; break; }
    }
    if (idx === -1) return;
    fleet[idx].products = fleet[idx].products.filter(function (p) { return p.variantId !== variantId; });
    delete fleet[idx].product;
    write(FLEET_KEY, fleet);
    emit('speedyreorder:fleet-updated');
  }

  function isListLocked() {
    return !!read(LOCKED_KEY, true);
  }

  /* Lets the account-sync layer (assets/speedy-reorder-account.js) overwrite
     local storage with the customer's account data without knowing this
     module's internal key names. */
  function importAccountData(data) {
    if (data && Array.isArray(data.fleet)) {
      write(FLEET_KEY, data.fleet);
    }
    if (data && typeof data.locked === 'boolean') {
      write(LOCKED_KEY, data.locked);
    }
    emit('speedyreorder:fleet-updated');
  }

  function setListLocked(locked) {
    write(LOCKED_KEY, !!locked);
    emit('speedyreorder:fleet-updated');
  }

  function isCompatible(printerCollectionHandles) {
    if (!isListLocked()) return true;
    var fleet = getFleet();
    if (!fleet.length) return true;
    if (!printerCollectionHandles || !printerCollectionHandles.length) return true;
    return fleet.some(function (f) {
      return printerCollectionHandles.indexOf(f.collectionHandle) !== -1;
    });
  }

  function searchPrinterCollections(query, callback) {
    fetch(
      '/search/suggest.json?q=' +
        encodeURIComponent(query) +
        '&resources[type]=collection&resources[limit]=10&resources[options][unavailable_products]=last'
    )
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        var collections = (data && data.resources && data.resources.results && data.resources.results.collections) || [];
        callback(collections);
      })
      .catch(function () { callback([]); });
  }

  function fetchCollectionProducts(handle, callback) {
    fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=50')
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) { callback((data && data.products) || []); })
      .catch(function () { callback([]); });
  }

  function addToCart(items, callback) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) { return res.json().then(function (body) { return { ok: res.ok, body: body }; }); })
      .then(function (result) { callback(result.ok, result.body); })
      .catch(function () { callback(false, null); });
  }

  return {
    getFleet: getFleet,
    saveFleetEntry: saveFleetEntry,
    removeFleetEntry: removeFleetEntry,
    addProductToEntry: addProductToEntry,
    removeProductFromEntry: removeProductFromEntry,
    isListLocked: isListLocked,
    importAccountData: importAccountData,
    setListLocked: setListLocked,
    isCompatible: isCompatible,
    searchPrinterCollections: searchPrinterCollections,
    fetchCollectionProducts: fetchCollectionProducts,
    addToCart: addToCart
  };
})();
